import React, { Component } from "react";
import MuiThemeProvider from "material-ui/styles/MuiThemeProvider";
import Title from "../SubscriptionsInfo/Title/Title";
import List from "../SubscriptionsInfo/List/SubscriptionList";
import SearchBar from "../SubscriptionsInfo/SearchBar/SearchBar";
import TagInfoTable from "./tag-info-table";
import Page from "../framework/Page/Page";
import isEmpty from "lodash/isEmpty";
import map from "lodash/map";
import { downLoadCSVFunc } from "../../utils/utility";
// css
import "../SubscriptionsInfo/subscription-info.css";
import moment from "moment";

//
import "./tags-info.css";
/**
 * use the component of SubscriptionInfo
 */
class TagInfo extends Component {
  constructor(props) {
    super(props);
    this.throttle = true;
    this.state = {
      requestParams: {
        clientId: "",
        pageNumber: 1,
        pageSize: 15,
        sortColumn: "clientName",
        order: "asc",
      },
    };
  }
  componentDidMount() {
    this.props.getTagsTotal();
    this.props.tagsSearch(this.state.requestParams);
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.search_results.clients && this.throttle) {
      this.setState(
        {
          requestParams: {
            ...this.state.requestParams,
            pageSize: nextProps.search_results.clients.total,
          },
        },
        () => {
          this.props.tagsAllSearch(this.state.requestParams);
        },
      );
      this.throttle = false;
    }
  }
  handleSearch(selectedItem) {
    let obj = {};
    if (selectedItem === "") {
      obj = {
        requestParams: {
          ...this.state.requestParams,
          clientId: "",
          pageNumber: 1,
          pageSize: 15,
        },
      };
      this.goToPage(1);
    } else {
      obj = {
        requestParams: {
          ...this.state.requestParams,
          clientId: selectedItem,
          pageNumber: 1,
          pageSize: 15,
        },
      };
    }
    this.setState(obj, () => {
      this.props.tagsSearch(this.state.requestParams);
    });
  }
  nextBeClick(page) {
    this.pageAbleFunc(page);
  }
  previousBeClick(page) {
    this.pageAbleFunc(page);
  }
  goToPage(page) {
    this.pageAbleFunc(page);
  }
  pageAbleFunc(val) {
    this.setState(
      {
        requestParams: {
          ...this.state.requestParams,
          pageNumber: val,
          pageSize: 15,
        },
      },
      () => {
        this.props.tagsSearch(this.state.requestParams);
      },
    );
  }
  handleSortByClientName() {
    this.setState(
      {
        requestParams: {
          ...this.state.requestParams,
          pageSize: 15,
          order: this.state.requestParams.order === "desc" ? "asc" : "desc",
        },
      },
      () => {
        this.props.tagsSearch(this.state.requestParams);
      },
    );
  }
  handleDownload() {
    let title = "AudienceAnywhere Tags,,,,,\r\n";
    let active = `${this.props.tags_total[0].label},${
      this.props.tags_total[0].value
    },,,,\r\n`;
    let inactive = `${this.props.tags_total[1].label},${
      this.props.tags_total[1].value
    },,,,\r\n`;
    //let total = `${this.props.tags_total[0].label},${this.props.tags_total[0].value},,,,\r\n`;

    let data = "";
    let itemFun = v => item => {
      data += `"${item.clientName}",${item.bizUnitName ||
        ""},"",${item.deploymentType || ""},${item.domain ||
        item.campaignName ||
        ""},${item.uuid || ""},${item.activeStatus || ""},${moment(
        item.createdDatetime,
      ).format("M/DD/YY") || ""}\r\n`;
    };
    for (const v of this.props.all_search_results.clients.data) {
      const managerName = isEmpty(v.accountManagers)
        ? ""
        : map(v.accountManagers, user => {
            return user.firstName + " " + user.lastName;
          }).join(",");

      if (v.children) {
        data += `"${v.clientName}","",${managerName},,,,,,\r\n`;
        v.children.forEach(itemFun(v));
      } else {
        data += `"${v.clientName}",${v.bizUnitName ||
          ""},${managerName},${v.deploymentType || ""},${v.domain ||
          v.campaignName ||
          ""},${v.uuid || ""},${v.activeStatus || ""},${moment(
          v.createdDatetime,
        ).format("M/DD/YY") || ""}\r\n`;
      }
    }
    let csv_string =
      title +
      //total +
      active +
      inactive +
      ",,,,,\r\n" +
      "Client Name,Business Unit Name,Account Manager,Tag Type,Domain/Campaign Name,Tag ID,Active/Inactive,Tag Creation Date\r\n" +
      data;
    downLoadCSVFunc(
      csv_string.trim(),
      "AA_Tags_" + moment().format("YYYYMMDD"),
    );
  }
  render() {
    return (
      <MuiThemeProvider>
        <div className="subscription-info dashboard-tag-info">
          <div className="title-wrapper">
            <Title crumb="Tags" handleDownload={() => this.handleDownload()} />
          </div>
          <div className="tag-info-container">
            <div className="common-wrapper">
              <h2>TOTAL NUMBER OF TAGS</h2>
              <div className="list">
                <List data={this.props.tags_total} />
              </div>
            </div>
            <div className="common-wrapper mt-20">
              <h2 className="border-title">TAGS</h2>
              <div className="search-bar">
                {this.props.clients && this.props.clients.length > 0 && (
                  <SearchBar
                    clients={this.props.clients}
                    handleSearch={selectedItem =>
                      this.handleSearch(selectedItem)
                    }
                  />
                )}

                <div className="tag-info-table-wrapper">
                  <TagInfoTable
                    handleSortByClientName={() => this.handleSortByClientName()}
                    tableHeaderArr={[
                      { label: "Client Name", value: 0 },
                      { label: "Business Unit Name", value: 1 },
                      // {label: 'Account Manager', value: 2},
                      { label: "Tag Type", value: 3 },
                      { label: "Domain/Campaign Name", value: 4 },
                      { label: "Tag ID", value: 5 },
                      { label: "Active/Inactive", value: 6 },
                    ]}
                    bodyDataArr={
                      this.props.search_results.clients
                        ? this.props.search_results.clients.data
                        : []
                    }
                    renderCols={{
                      addCol: "campaignName",
                      cols: [
                        "clientName",
                        "bizUnitName",
                        "deploymentType",
                        "domain",
                        "uuid",
                        "activeStatus",
                      ],
                    }}
                  />
                  <Page
                    nextBeClick={page => this.nextBeClick(page)}
                    pageNumber={
                      this.props.search_results.clients &&
                      this.props.search_results.clients.pageNumber
                    }
                    pageCount={
                      this.props.search_results.clients &&
                      this.props.search_results.clients.pageCount
                    }
                    pageSize={
                      this.props.search_results.clients &&
                      this.props.search_results.clients.pageSize
                    }
                    nextGroupBeClick={page => this.nextGroupBeClick(page)}
                    previousGroupBeClick={page =>
                      this.previousGroupBeClick(page)
                    }
                    previousBeClick={page => this.previousBeClick(page)}
                    pageBeClick={page => this.pageBeClick(page)}
                    total={
                      this.props.search_results.clients &&
                      this.props.search_results.clients.total
                    }
                    hasNext={
                      this.props.search_results.clients &&
                      this.props.search_results.clients.hasNext
                    }
                    hasPrevious={
                      this.props.search_results.clients &&
                      this.props.search_results.clients.hasPrevious
                    }
                    pagePlus={true}
                    selectRows={(page, row) => this.selectRows(page, row)}
                    goToPage={page => this.goToPage(page)}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </MuiThemeProvider>
    );
  }
}

export default TagInfo;



// WEBPACK FOOTER //
// ./src/components/TagsInfo/Index.jsx